export class FileUploader {
	static Options = {};
	static Lurker = {};

	static Initialize(options) {
		const existingLurker = document.getElementById("ipLurker");

		this.Lurker = existingLurker ?? document.createElementWithContents("input", "", {
			type: "file",
			id: "ipLurker",
			className: "d-none position-absolute"
		});

		if (!existingLurker) { document.body.appendChild(this.Lurker); }

		this.Options = {
			MaximumSize: 10485760,
			AllowedExtensions: [], ...options
		};

		if (this.Options.Buttons?.length) {
			[...(typeof this.Options.Buttons === "string" ? document.querySelectorAll(this.Options.Buttons) : this.Options.Buttons)]
				.filter(x => x != null)
				.forEach(button => button.onclick = () => this.#GetFiles());
		}

		if (this.Options.DropAreas?.length) {
			((typeof this.Options.DropAreas === "string" ? document.querySelectorAll(this.Options.DropAreas) : this.Options.DropAreas))
				.forEach(area => {
					Object.assign(area ?? {}, {
						ondragenter: ev => ev.preventDefault(),
						ondragover: ev => ev.preventDefault(),
						ondrop: this.#OnDrop
					});
				});
		}
	}

	static #OnDrop = ev => {
		ev.preventDefault();

		const items = ev.dataTransfer.items,
			files = ev.dataTransfer.files;

		if (this.Options.DragDropMessage) {
			Dialog.ShowConfirmation("Are you sure?", this.Options.DragDropMessage).then(proceed => {
				if (!proceed) { return; }

				if (ev.dataTransfer.items?.length) {
					this.#ProcessFiles(Array.from(items).filter(x => x.kind === "file").map(y => y.getAsFile()));
				} else {
					this.#ProcessFiles(files);
				}
			});
		} else if (items) {
			this.#ProcessFiles(Array.from(items).filter(x => x.kind === "file").map(y => y.getAsFile()));
		} else {
			this.#ProcessFiles(files);
		}
	}

	static #getFileData(reader) {
		return btoa(new Uint8Array(reader.result).reduce((data, byte) => data + String.fromCharCode(byte), ''))
	}

	static #getImageSrc(reader, file) {
		return `data:${file.type};base64,${this.#getFileData(reader)}`;
	}

	static getAuxiliumFile(file, reader) {
		const auxFile = Object.assign(file, {
			getData: () => this.#getFileData(reader),
			getImageSrc: () => this.#getImageSrc(reader, auxFile)
		});

		return auxFile;
	}

	static async #ProcessFiles(receivedFiles) {
		const files = [];

		return new Promise(res => {
			if (receivedFiles.length) {
				const reader = new FileReader();
				let index = 0;

				const mapper = new Promise(resolve => {
					reader.onload = async () => {
						const file = this.getAuxiliumFile(receivedFiles[index], reader);

						if (!this.Options.AllowedExtensions.length || this.Options.AllowedExtensions.includes(file.name.split(".").pop())) {
							if (file.size <= this.Options.MaximumSize || this.Options.MaximumSize < 1) {
								files.push(file);
							} else if (typeof this.Options.OnFileTooLarge === "function") {
								await this.Options.OnFileTooLarge(file);
							}
						}

						if (index < receivedFiles.length - 1) {
							reader.readAsArrayBuffer(receivedFiles[++index]);
						} else {
							resolve();
						}
					}
				});

				reader.readAsArrayBuffer(receivedFiles[0]);

				mapper.then(() => {
					this.Options.OnComplete?.(files);

					res(files);
				});
			}
		});
	}

	static #GetFiles() {
		return new Promise(resolve => {
			Object.assign(this.Lurker, {
				accept: this.Options.AllowedExtensions.map(x => `.${x}`).join(","),
				onchange: () => this.#ProcessFiles(this.Lurker.files).then(files => resolve(files))
			});

			if (this.Options.Multiple) {
				this.Lurker.setAttribute("multiple", "");
			}

			if (this.Options.IsDirectory) {
				Object.assign(this.Lurker, {
					directory: "",
					webkitdirectory: "",
					multiple: ""
				});
			}

			this.Lurker.click();
		});
	}
}